import { Injectable } from '@angular/core';
import * as angular from 'angular';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class QueryTableModel extends ModeModelBase {
  token: any;
  view: any;
  vizLink: any;
  override _name = 'queryTable';
  override idAttribute = 'token';
  override belongsTo = 'query';
  override parentIdAttribute = 'token';
  override attributes = [{ name: 'view', default: null, type: 'text' }];
  override initialize(resource) {
    if (resource && resource.hasLink('report_viz_web')) {
      this.vizLink = resource.links('report_viz_web').href;
    }
  }
  getVizReportRunLink(reportRunToken) {
    return this._resource.hasLink('report_run_viz_web')
      ? this._resource.links('report_run_viz_web').$expand({ token: reportRunToken }, { excludeSSLPort: true })
      : '';
  }
  renderEmbed(reportRunToken) {
    return angular.extend({}, this.view, {
      _dataset: this.parent,
      _token: this.token,
      _vizLink: this.vizLink,
      _vizReportRunLink: this.getVizReportRunLink(reportRunToken),
    });
  }
}

@Injectable({ providedIn: 'root' })
export class QueryTableModelAccessor extends ModelAccessorBase<QueryTableModel> {
  override name = 'queryTable';
  override idAttribute = 'token';
  override parentModel = 'query';
  override parentIdAttribute = 'token';
  override createAttributes = ['query'];

  EmptyTable() {
    return {};
  }
  override createModel(resource, opts?) {
    const model = new QueryTableModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.queryTable');
  }
}
